import React from 'react';
import { Layout } from 'antd';
import { SidebarProvider, SidebarInset } from '../ui/sidebar';
import './Main.scss';
import { Toaster } from '../ui/toaster';
import AppSidebar from '../Menu/Sidebar';

const { Content } = Layout;

const MainLayout = ({ children }) => {
  return (
    <SidebarProvider>
      <div className="MainLayout" style={{ display: 'flex', minHeight: '100vh' }}>
        <AppSidebar />
        <SidebarInset className="bg-white">
          {/* <MainHeader /> */}
          {/* <header className="flex h-16 shrink-0 items-center gap-2 border-b px-4">
            <SidebarTrigger className="-ml-1" />
          </header> */}
          <Toaster />
          <div className="max-w-6xl mx-auto w-full mt-5 ml-10 px-4 py-6 bg-white">{children}</div>
        </SidebarInset>
      </div>
    </SidebarProvider>
  );
};

export default MainLayout;
